import apiClient from "./api";

export interface SalesReturnItem {
  id?: number;
  sale_return_id?: number;
  product_id: number;
  product_code?: string;
  product_name?: string;
  product_type?: number;
  quantity: number;
  unit_price: number;
  price?: number;
  subtotal?: number;
  tax?: number;
  discount?: number;
  total?: number;
  cost?: number;
  product?: {
    id?: number;
    code?: string;
    name?: string;
    type?: number;
  };
}

export interface SalesReturnRecord {
  id: number;
  return_ref: string;
  sale_id: number;
  reference_no?: string;
  customer_id?: number | null;
  customer_code?: string | null;
  customer_name?: string | null;
  warehouse_id: number;
  warehouse_code?: string | null;
  warehouse_name?: string | null;
  note?: string | null;
  staff_note?: string | null;
  total?: number;
  discount?: number;
  total_discount?: number;
  tax?: number;
  shipping?: number;
  grand_total: number;
  paid?: number;
  paid_by?: string | null;
  status?: string;
  total_items?: number;
  created_at?: string;
  updated_at?: string;
  items?: SalesReturnItem[];
  customer?: {
    id?: number;
    code?: string;
    name?: string;
  } | null;
  warehouse?: {
    id?: number;
    code?: string;
    name?: string;
  } | null;
  sale?: {
    id?: number;
    reference_no?: string;
  } | null;
}

export interface SalesReturnListParams {
  warehouse_id?: number;
  customer_id?: number;
  status?: string;
  q?: string;
  search?: string;
  page?: number;
  per_page?: number | "all";
}

export interface PaginatedResponse<T> {
  data: T[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
  from: number;
  to: number;
}

export interface SalesReturnPayload {
  sale_id: number;
  warehouse_id: number;
  return_ref: string;
  reference_no?: string;
  customer_id?: number | null;
  customer_code?: string | null;
  customer_name?: string | null;
  warehouse_code?: string | null;
  warehouse_name?: string | null;
  note?: string;
  staff_note?: string;
  status?: string;
  discount?: number;
  total_discount?: number;
  tax?: number;
  shipping?: number;
  total?: number;
  grand_total: number;
  paid?: number;
  paid_by?: string;
  items: SalesReturnItem[];
}

const salesReturnService = {
  async getSalesReturns(params?: SalesReturnListParams): Promise<PaginatedResponse<SalesReturnRecord>> {
    const response = await apiClient.get("/return-sale", { params });
    return response.data.data;
  },

  async getSalesReturn(id: number): Promise<SalesReturnRecord> {
    const response = await apiClient.get(`/return-sale/${id}`);
    return response.data.data ?? response.data;
  },

  async createSalesReturn(payload: SalesReturnPayload): Promise<SalesReturnRecord> {
    const response = await apiClient.post("/return-sale", payload);
    return response.data.data ?? response.data;
  },

  async updateSalesReturn(id: number, payload: SalesReturnPayload): Promise<SalesReturnRecord> {
    const response = await apiClient.put(`/return-sale/${id}`, payload);
    return response.data.data ?? response.data;
  },

  async deleteSalesReturn(id: number): Promise<void> {
    await apiClient.delete(`/return-sale/${id}`);
  },

  async getNextReference(): Promise<string> {
    const response = await apiClient.get("/return-sale/next-reference");
    return response.data.data ?? response.data;
  },
};

export default salesReturnService;
